module.exports = __webpack_public_path__ + "static/productPreview-ccf9e66f26b70c4189095807a12a998b.png";